import React from 'react';
import PropTypes from 'prop-types';
import { Table } from '@statsbomb/kitbag-components';
import classNames from 'classnames';
import { StyledCompactTable } from '../GameSnapFormations/SnapList.styles';
import Dimmer from '../../../components/Dimmer/Dimmer';
import LoaderLabelled from '../../../components/LoaderLabelled/LoaderLabelled';

const addRow = function (event, selectedEventId, onRowClick) {
  let ffCount = 0;
  let ffAnonCount = 0;
  if (event.freezeFrames && event.freezeFrames.length > 0) {
    const nonBallFFs = event.freezeFrames.filter((f) => f.playerIndex >= 0);
    const anonFFs = event.freezeFrames.filter(
      (f) => f.playerIndex >= 0 && !f.player
    );
    ffCount = nonBallFFs.length;
    ffAnonCount = anonFFs.length;
  }

  const classes = classNames({
    active: event.id === selectedEventId,
    disabled: ffCount <= 0,
  });

  return (
    <Table.Row key={event.id} className={classes}>
      <Table.DataCell onClick={() => onRowClick(event)}>
        {event.name}
      </Table.DataCell>
      <Table.DataCell>
        {`${ffCount}${ffAnonCount > 0 ? ` (${ffAnonCount})` : ''}`}
      </Table.DataCell>
    </Table.Row>
  );
};

const EventList = function ({ events, loading, selectedEventId, onRowClick }) {
  return (
    <StyledCompactTable>
      <Table>
        <Table.Body>
          {!loading &&
            events &&
            events.map((d) => addRow(d, selectedEventId, onRowClick))}
          {loading && (
            <Table.Row>
              <Table.DataCell>
                <Dimmer>
                  <LoaderLabelled text="Loading" />
                </Dimmer>
              </Table.DataCell>
            </Table.Row>
          )}
        </Table.Body>
      </Table>
    </StyledCompactTable>
  );
};

EventList.propTypes = {
  events: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  loading: PropTypes.bool,
  selectedEventId: PropTypes.string,
  onRowClick: PropTypes.func,
};

EventList.defaultProps = {
  events: [],
  loading: false,
  selectedEventId: '',
  onRowClick: () => {},
};

export default EventList;
